import React from 'react';
import { buildRadioLiveCapsuleMessage } from './radioLiveCapsuleMessages';

export default function RadioLiveCapsule({
  capsule = null,
  activeQueue = [],
  currentIndex = 0,
  isPlaying = false,
  signals = null,
  transientFeedbackSignal = null,
  onExpand,
}) {
  const message = buildRadioLiveCapsuleMessage({
    currentCapsule: capsule,
    queue: activeQueue,
    currentIndex,
    isPlaying,
    signals,
    transientFeedbackSignal,
  });
  const canExpand = Boolean(capsule?.canPlay);

  const artwork = capsule?.coverArtUrl ? (
    <img src={capsule.coverArtUrl} alt="" width="44" height="44" decoding="async" />
  ) : (
    <span className="jg-radio-live-capsule-mark" aria-hidden="true">
      JG
    </span>
  );

  const content = (
    <>
      <span className="jg-radio-live-capsule-art">{artwork}</span>
      <span className="jg-radio-live-capsule-copy">
        <span className="jg-radio-live-capsule-topline">
          <strong>{message.brand}</strong>
          {message.liveLabel ? (
            <span
              className={[
                'jg-radio-live-capsule-live',
                message.isPlaying ? 'is-playing' : '',
              ]
                .filter(Boolean)
                .join(' ')}
            >
              <span className="jg-radio-live-capsule-live-bars" aria-hidden="true">
                <span />
                <span />
                <span />
              </span>
              {message.liveLabel}
            </span>
          ) : null}
        </span>
        <span className="jg-radio-live-capsule-title">
          <span>{message.status}</span>
          {message.title}
        </span>
        {message.artistName ? (
          <span className="jg-radio-live-capsule-artist">
            {message.artistName}
          </span>
        ) : null}
        {message.secondaryLabel ? (
          <span className="jg-radio-live-capsule-signal">
            <span>{message.secondaryLabel}</span>
            {message.secondaryTitle ? (
              <strong>
                {message.secondaryTitle}
                {message.secondaryArtistName
                  ? ` - ${message.secondaryArtistName}`
                  : ''}
              </strong>
            ) : null}
          </span>
        ) : null}
      </span>
    </>
  );

  if (!canExpand) {
    return (
      <div
        className="jg-radio-live-capsule is-disabled"
        role="status"
        aria-label="Joe Galaxy Radio is getting ready"
      >
        {content}
      </div>
    );
  }

  const handleKeyDown = (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    onExpand?.();
  };

  return (
    <button
      type="button"
      className="jg-radio-live-capsule"
      onClick={onExpand}
      onKeyDown={handleKeyDown}
      aria-label="Open Joe Galaxy Radio dock"
    >
      {content}
    </button>
  );
}
